import { render, staticRenderFns } from "./tradeupload-info.vue?vue&type=template&id=6422584f&"
import script from "./tradeupload-info.vue?vue&type=script&lang=js&"
export * from "./tradeupload-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeupload-info.vue"
export default component.exports